<template>
  <div class="motivate">
    <div class="motivate_form">
      <el-form
        :inline="true"
        :model="motivateForm"
        style="
          padding-top: 20px;
          padding-left: 20px;
          margin-bottom: 20px;
          background-color: #fff;
          border-radius: 8px;
        "
        size="small"
      >
        <el-form-item label="群组名称">
          <el-input
            v-model="motivateForm.name"
            placeholder="请输入群组名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="getData"
            >查询</el-button
          >
          <el-button type="info" size="small" @click="motivateForm.name = ''"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="motivate_table">
      <div class="table_btn">
        <div>
          <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="showDialog('add')"
          >新增</el-button
        >
        </div>
      </div>
      <el-table
        :data="tableData"
        stripe
        height="80%"
        size="small"
        :header-cell-style="{
          'background-color': '#84aace4a',
          color: '#343333',
          'text-align': 'center',
        }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column prop="name" label="群组名称"></el-table-column>
        <el-table-column prop="leader" label="负责人"></el-table-column>
        <el-table-column label="是否负责人代管">
          <template slot-scope="scope">
            <span>{{ scope.row.isTrustee ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="createdByStr" label="创建人"></el-table-column>
        <el-table-column prop="updateTime" label="修改时间"></el-table-column>
        <el-table-column prop="updatedByStr" label="修改人"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-tooltip effect="dark" content="管理费" placement="top-end">
              <el-button
                type="success"
                icon="el-icon-setting"
                circle
                size="mini"
                v-show="
                  authorization(
                    '/home-admin/routineManage/fee-group-manage/management-fee'
                  )
                "
                @click="managementExpense(scope.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              content="编辑"
              placement="top-end"
              v-show="
                authorization('/home-admin/routineManage/incentive-manage/edit')
              "
            >
              <el-button
                type="primary"
                icon="el-icon-edit"
                circle
                size="mini"
                style="margin-left: 5px"
                @click="showDialog(scope.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="管理人员" placement="top-end">
              <el-button
                type="warning"
                icon="el-icon-monitor"
                circle
                style="margin-left: 5px; margin-right: 5px"
                size="mini"
                @click="openUserView(scope.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              content="删除"
              placement="top-end"
              v-show="
                authorization('/home-admin/routineManage/incentive-manage/del')
              "
            >
              <el-popconfirm
                title="确认删除吗？"
                @confirm="deleteData(scope.row)"
              >
                <!-- @confirm="deleteUser(scope.row)" -->
                <el-button
                  content="删除"
                  slot="reference"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  size="mini"
                ></el-button>
              </el-popconfirm>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div
        style="
          padding-top: 20px;
          height: 40px;
          background-color: #fff;
          width: 100%;
          border-radius: 0 0 8px 8px;
          text-align: right;
        "
      >
        <el-pagination
          background
          :page-sizes="sizes"
          layout="total,sizes,prev,pager,next"
          :total="total"
          @current-change="handleCurrentChange"
          @size-change="sizeChange"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :title="isEdit ? '编辑' : '新增'"
      :visible.sync="dialogFormEdit"
      width="700px"
      :close-on-click-modal="false"
      @clise="closeDialog"
    >
      <div>
        <el-form
          :model="editForm"
          :rules="editFormRules"
          ref="editForm"
          size="small"
          label-width="160px"
          style="padding-right: 20px"
        >
          <el-form-item label="群组名称" prop="name">
            <el-input
              v-model="editForm.name"
              placeholder="请输入群组名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="负责人" prop="leaderId">
            <el-select
              style="width: 100%"
              filterable
              v-model="editForm.leaderId"
              placeholder="请选择"
              @change="leaderChange"
            >
              <el-option
                v-for="item in allUserList"
                :key="item.id"
                :label="item.userName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否负责人代管:">
            <el-switch v-model="editForm.isTrustee"></el-switch>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" style="margin-top: 50px">
        <el-button @click="closeDialog" size="small">取 消</el-button>
        <el-button type="primary" @click="submit" size="small">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 人员管理弹出层 -->
    <el-dialog
      title="群组人员"
      :visible.sync="dialogFormGroupUser"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form
        :model="groupUserArray"
        :rules="groupUserRules"
        ref="groupUserArray"
        label-width="160px"
        size="small"
        style="width: 600px"
      >
        <el-form-item label="群组名称" prop="name">
          {{ groupUserArray.name }}
        </el-form-item>
        <el-form-item label="负责人" prop="leaderObj">
          {{ groupUserArray.leader }}
        </el-form-item>
        <el-form-item label="群组人员" prop="userList">
          <el-select
            filterable
            v-model="groupUserArray.userIdList"
            multiple
            style="width: 100%"
            placeholder="请选择"
          >
            <el-option
              v-for="item in userList"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin-top: 50px">
        <el-button @click="dialogFormGroupUser = false" size="mini"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="addGroupSubMit('groupUserArray')"
          size="mini"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { authorization } from "../../../authorization/authorization";
export default {
  name: "Motivate",
  data() {
    return {
      motivateForm: {
        name: "",
      },
      tableData: [],
      total: 0,
      sizes: [10, 15, 20, 50],
      dialogFormEdit: false,
      editForm: {
        name: "",
        leaderId: "",
        isTrustee: true,
        leader: "",
      },
      editFormRules: {
        name: [{ required: true, message: "请输入群组名称", trigger: "blur" }],
        leaderId: [
          { required: true, message: "请输入负责人", trigger: "blur" },
        ],
      },
      isEdit: false,
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      allUserList: this.$store.state.allUserList || [],
      id: null,
      dialogFormGroupUser: false,
      groupUserArray: {
        groupId: "",
        name: "",
        leader: "",
        userIdList: [],
      },
      groupUserRules: {
        userIdList: [
          { required: true, message: "请选择群组人员", trigger: "blur" },
        ],
      },
      userList: [],
    };
  },
  created() {
    this.getData(true);
    this.loadAllUserList();
  },
  methods: {
    authorization,
    // 加载所有用户列表
    async loadAllUserList() {
      try {
        // 调用store的action来获取最新的用户列表
        await this.$store.dispatch('setAllUserList');
        // 更新本地数据
        this.allUserList = this.$store.state.allUserList;
      } catch (error) {
        console.error('加载用户列表失败:', error);
        this.$message.error('加载用户列表失败');
      }
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.getData(false);
    },
    sizeChange(val) {
      this.page.pageSize = val;
      this.getData(false);
    },
    showDialog(data) {
      if (data === "add") {
        this.isEdit = false;
      } else {
        this.editForm.name = data.name;
        this.editForm.leaderId = data.leaderId;
        this.editForm.isTrustee = data.isTrustee;
        this.editForm.leader = data.leader;
        this.id = data.id;
        this.isEdit = true;
      }
      // 确保用户列表是最新的
      this.loadAllUserList();
      this.dialogFormEdit = true;
    },
    managementExpense(data) {
      this.$router.push({
        path: "/home-admin/admin/manage-cost",
        query:{
          id:data.id
        }
      });
    },
    leaderChange(item) {
      this.editForm.leaderId = item;
      var index = this.allUserList.findIndex((p) => p.id == item);
      this.editForm.leader = this.allUserList[index].userName;
    },
    closeDialog() {
      this.editForm = {
        name: "",
        leaderId: "",
        isTrustee: true,
        leader: "",
      },
      this.$refs.editForm.resetFields();
      this.dialogFormEdit = false;
    },
    submit() {
      if (this.isEdit) {
        this.edit();
      } else {
        this.add();
      }
    },
    edit() {
      this.axios({
        url: `/management-fee-group/update-group/${this.id}`,
        method: "post",
        data: this.editForm,
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success("编辑成功");
          this.getData(true);
          this.closeDialog();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    add() {
      this.axios({
        url: "/management-fee-group/add-group",
        method: "post",
        data: this.editForm,
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success("新增成功");
          this.getData(true);
          this.closeDialog();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    deleteData(data) {
      this.axios({
        url: `/management-fee-group/delete-group/${data.id}`,
        method: "DELETE",
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success("删除成功");
          this.getData(true);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getData(flag) {
      if (flag) {
        this.page.pageNum = 1;
        this.page.pageSize = 10;
      }
      const data = {
        queryInfoParams: {
          name: this.motivateForm.name,
        },
        size: this.page.pageSize,
        page: this.page.pageNum,
      };
      this.axios({
        url: "/management-fee-group/select-group-list",
        method: "post",
        data,
      }).then((res) => {
        this.tableData = res.data.data.list;
        this.total = res.data.data.total;
      });
    },
    openUserView(row) {
      this.groupUserArray = { ...row };
      this.groupUserArray.userIdList = [];
      if (row.userIdList != null) {
        for (let i = 0; i < row.userIdList.length; i++) {
          this.groupUserArray.userIdList.push(row.userIdList[i]);
        }
      }
      // 确保用户列表是最新的
      this.loadAllUserList().then(() => {
        this.queryUserList(row.leaderId);
        this.dialogFormGroupUser = true;
      });
    },
    queryUserList(userId) {
      this.userList = [];
      for (let i = 0; i < this.allUserList.length; i++) {
        this.userList.push(this.allUserList[i]);
      }
    },
    addGroupSubMit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.axios({
            method: "post",
            url: "/management-fee-group/update-group-users/" + this.groupUserArray.id,
            data: this.groupUserArray,
          }).then((res) => {
            if (res.data.code === 200) {
              this.dialogFormGroupUser = false;
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.getData(false);
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.motivate {
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: rgb(238, 238, 238);
  box-sizing: border-box;
}
.motivate_form {
  width: 100%;
  overflow: hidden;
}
.motivate_table {
  height: 100%;
  padding: 20px 5px 0 20px;
  background-color: #fff;
  border-radius: 8px;
}
.table_btn {
  margin-bottom: 10px;
}
</style>
